import React from 'react';
import { pickWithPriority } from 'Helpers/Affordances';
import fr from 'facet-rest';
import NextUpReviewPageButton from './NextUpReviewPageButton';

const NextUpReviewButtonPicker = ({ resource, buttonText }) => {
  return pickWithPriority(resource, [
    [fr.relationships.nextUpReviewPage.name, <NextUpReviewPageButton buttonText={buttonText} />],
  ], null);
};

export default NextUpReviewButtonPicker;
